import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import configuration from '../../config';
// Msal Configurations

const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_policy',
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://tsrbo.b2clogin.com/tsrbo.onmicrosoft.com/B2C_1_policy',
        },
    },
    authorityDomain: 'tsrbo.b2clogin.com',
};

const config: Configuration = {
    auth: {
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        clientId: configuration.clientId,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: configuration.redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};

// Authentication Parameters
export const loginRequest = {
    redirectStartPage: configuration.redirectUri,
    scopes: ['openid', ...configuration.b2cScopes],
};

export const tokenRequest = {
    scopes: [...configuration.b2cScopes],
    forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const authProvider = new PublicClientApplication(config);
